define(['exports', 'react', './styles/RecentStatsCounter.css'], function (exports, _react) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var RecentStatsCounter = function RecentStatsCounter(_ref) {
    var count = _ref.count,
        label = _ref.label,
        period = _ref.period,
        icon = _ref.icon;

    return _react2.default.createElement(
      'div',
      { className: 'px2 py3 grey-border flex default justify-between' },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          count
        ),
        _react2.default.createElement(
          'div',
          { className: 'pt1' },
          label
        ),
        _react2.default.createElement(
          'div',
          { className: 'pt1 h6' },
          period
        )
      ),
      _react2.default.createElement(
        'div',
        null,
        icon
      )
    );
  };

  exports.default = RecentStatsCounter;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/common/RecentStatsCounter.js
// module id = 1169
// module chunks = 0